import * as authSagas from './auth.js'
import * as userSagas from './users.js'
import * as errorSagas from './errors.js'
import * as forgotPasswordSagas from './forgotPassword.js'
import * as newPasswordSagas from './newPassword.js'
import * as changePasswordSagas from './changePassword.js'
import * as webinarSagas from './webinars.js'
import * as subscriptionSagas from './subscriptions.js'
import * as vimeoSagas from './vimeo.js'
import * as quizSagas from './quiz.js'
import * as suggestionSagas from './suggestions.js'
import * as confirmEmailSagas from './confirmEmail.js'

import * as adminUsersSagas from './admin/users.js'
import * as adminWebinarsSagas from './admin/webinars.js'
import * as dashboardUsersSagas from './admin/dashboard.js'

import * as adminSponsorsSagas from './admin/sponsors.js'
import * as sponsorsSagas from './sponsors.js'

import { fork } from 'redux-saga/effects'

const sagas = {
  ...authSagas,
  ...userSagas,
  ...errorSagas,
  ...forgotPasswordSagas,
  ...newPasswordSagas,
  ...changePasswordSagas,
  ...webinarSagas,
  ...subscriptionSagas,
  ...vimeoSagas,
  ...quizSagas,
  ...suggestionSagas,
  ...confirmEmailSagas,
  ...adminUsersSagas,
  ...dashboardUsersSagas,
  ...adminWebinarsSagas,
  ...adminSponsorsSagas,
  ...sponsorsSagas
}

export default function* root() {
    yield [
      ...Object.keys(sagas).map(sagaKey => fork(sagas[sagaKey]))
    ];
}



/** WEBPACK FOOTER **
 ** ./src/sagas/index.js
 **/